<template>
  <div>
    <div class="form-group">
      <label>ФИО</label>
      <input type="text" v-model="search" class="search" placeholder="Фамилия, имя, отчество" @keyup.enter="setPlayer">
      <p v-if="error" class="error">Пользователь не найден, проверьте ФИО</p>
    </div>
    <notification-modal @close="no_have_test = false" v-if="no_have_test"></notification-modal>
  </div>
</template>

<script>
  import PlayersService from '@/services/PlayersService'
  import NotificationModal from '@/components/modal/NotificationModal'

export default {
  name: 'EnterName',
  components: {
    NotificationModal
  },
  data () {
    return {
      search: '',
      players: [],
      resultCount: [],
      player: {
        last_name: '',
        first_name: '',
        middle_name: ''
      },
      no_have_test: false,
      error: false
    }
  },
  computed: {
    slug () {
      return this.$route.params.slug
    },
    groupId () {
      return this.$store.getters.groupId
    },
    playerId () {
      return this.$store.getters.getPlayer.id
    }
  },
  created () {
    PlayersService.getAll().then(
      (response) => {
        this.players = response
        this.resultCount = this.players.results
      }
    )
  },
  methods: {
    clearX () {
      this.search = null
      this.error = null
    },
    setPlayer () {
      let vm = this

      PlayersService.getAll(vm.search).then(
        (response) => {
          this.players = response
          this.resultCount = this.players.results
          this.resultCount.forEach(function (player) {
            const fioBig = `${player.last_name} ${player.first_name} ${player.middle_name}`
            const fioLow = `${player.last_name} ${player.first_name} ${player.middle_name}`.toLowerCase()
            const fiBig = `${player.last_name} ${player.first_name}`
            const fiLow = `${player.last_name} ${player.first_name}`.toLowerCase()
            if (vm.search.replace('  ', ' ') === fioBig || vm.search.replace('  ', ' ') === fioLow || vm.search.replace('  ', ' ') === fiBig || vm.search.replace('  ', ' ') === fiLow) {
              vm.$store.dispatch('setPlayer', player)

              if (player.group_set.length === 1) {
                vm.$emit('setPage', 4)
              } else if (player.group_set.length > 1) {
                vm.$emit('setPage', 2)
              } else if (player.group_set.length === 0) {
                vm.no_have_test = true
              }
            }
          })
          if (this.players.count === 0) {
            vm.error = true
          }
        }
      )
    }
  }
}
</script>

<style lang="scss">
  p.error {
    font-size: 13px;
    color: darkred;
  }

  .search-block {
    position: relative;
    padding-bottom: 200px;
    display: flex;

    span.clearx {
      position: relative;
      right: 140px;
      top: 12px;
      cursor: pointer;
      color: #b7b7b7;
    }

    input {
      width: 72% !important;
      height: 48px;
      display: flex;
    }

    .btn {
      background-color: #1F88D9;
      color: #fff;
      margin-left: -10px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    div.list-group {
      text-align: left;
      display: flex;
      flex-direction: column;
      width: 50%;
      overflow: hidden;
      background-color: #F2F8FC;
      border: none;

      a.list-group-item {
        padding: 15px;

        &:hover {
          background-color: #1F88D9;
          color: #fff;
        }
      }

      .vbt-autcomplete-list {
        padding-top: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/EnterName.vue